export function parseQueryString(params) {
  return Object.keys(params)
    .reduce((queryParams, key) => {
      !!params[key] && queryParams.push(key + "=" + params[key]);
      return queryParams;
    }, [])
    .join("&");
}
